// extracted by mini-css-extract-plugin
export default {"container":"LW-z","title":"MW-z","link":"NW-z"};